import { AxiosRequestConfig } from 'axios';

import axiosInstance, { TAxiosConfigExtra } from './service';

const defaultTransformData = (res: any) => res.data;

export const get = <T = any, P = Record<string, any>>(
  url: string,
  params?: P,
  config?: AxiosRequestConfig & TAxiosConfigExtra,
): Promise<IResponse<T>> => {
  return axiosInstance<IResponse<T>>({
    method: 'GET',
    url,
    params,
    ...config,
  })
    .then((res) => {
      return config?.transformData ? config.transformData(res) : defaultTransformData(res);
    })
    .catch((e) => e);
};

export const post = <T = any, P = Record<string, string>>(
  url: string,
  params?: P,
  config?: AxiosRequestConfig & TAxiosConfigExtra,
): Promise<IResponse<T>> => {
  return axiosInstance<IResponse<T>>({
    method: 'POST',
    url,
    params,
    ...config,
  })
    .then((res) => {
      return config?.transformData ? config.transformData(res) : defaultTransformData(res);
    })
    .catch((e) => e);
};

export const postData = <T = any, P = Record<string, string>>(
  url: string,
  data?: P,
  config?: AxiosRequestConfig & TAxiosConfigExtra,
): Promise<IResponse<T>> => {
  return axiosInstance<IResponse<T>>({
    method: 'POST',
    url,
    data,
    ...config,
  })
    .then((res) => {
      return config?.transformData ? config.transformData(res) : defaultTransformData(res);
    })
    .catch((e) => e);
};
